<script>
	import { api } from "./../libs/api.js";
	import { config } from './../libs/config.js';

	import { Link } from 'svelte-routing';
	import { _ } from 'svelte-i18n';

	import BaseLayer from "./../components/BaseLayer.svelte";

	let user = api.get_user_self()

	let current_language = config.language

	function handle_language_selection(lang_id) {
		return async function language_selection(event) {
			current_language = lang_id
		}
	}

	async function handle_save_language(event) {
		config.language = current_language
	}

	async function handle_logout(event) {
		await api.logout();
		user = {};
	}
</script>

<BaseLayer>
	<div class="m-4">
		<h3 class="page-title mb-4">{$_('profile.title')}</h3>
		{#await user then value}
		<ul class="menu w-full">
			{#if value.data && value.data[0]}
			<li>
				<div class="flex justify-between">
					<div class="block">
						<h4 class="card-title -mb-1 py-0">{value.data[0].first_name} {value.data[0].last_name}</h4>
						<small class="py-0">{value.data[0].email}</small>
					</div>
					<div>
						<a on:click={handle_logout}>
						<svg class="w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path class="fill-error" d="M160 416H96c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h64c17.67 0 32-14.33 32-32S177.7 32 160 32H96C42.98 32 0 74.98 0 128v256c0 53.02 42.98 96 96 96h64c17.67 0 32-14.33 32-32S177.7 416 160 416zM502.6 233.4l-128-128c-12.51-12.51-32.76-12.49-45.25 0c-12.5 12.5-12.5 32.75 0 45.25L402.8 224H192C174.3 224 160 238.3 160 256s14.31 32 32 32h210.8l-73.38 73.38c-12.5 12.5-12.5 32.75 0 45.25s32.75 12.5 45.25 0l128-128C515.1 266.1 515.1 245.9 502.6 233.4z"/></svg>
						</a>
					</div>
				</div>
			</li>
			{:else}
			<li>
				<Link class="btn btn-accent mx-8 my-4" to="login">{$_('login.login')}</Link>
			</li>
			{/if}
			<li>
				<a href="#language-modal" class="link link-hover">{$_('profile.language')}</a>

				<div class="modal" id="language-modal">
					<div class="modal-box">
						<h3 class="font-bold text-lg">{$_('profile.select')}</h3>
						<ul class="menu bg-base-100 w-full mt-8">
							<li>
								<a class="{current_language == 'en' ? 'active' : ''}" on:click={handle_language_selection('en')}>
									<span class="mr-2">🇬🇧️</span> English
								</a>
							</li>
							<li>
								<a class="{current_language == 'it' ? 'active' : ''}" on:click={handle_language_selection('it')}>
									<span class="mr-2">🇮🇹️</span> Italiano
								</a>
							</li>
								<li>
									<a class="{current_language == 'gr' ? 'active' : ''}" on:click={handle_language_selection('gr')}>
									<span class="mr-2">🇬🇷️</span> Ελληνικά
								</a>
							</li>
								<li>
									<a class="{current_language == 'hr' ? 'active' : ''}" on:click={handle_language_selection('hr')}>
									<span class="mr-2">🇭🇷️</span> Hrvatski
								</a>
							</li>
						</ul>

						<div class="modal-action">
							<a href="#" class="btn w-full" on:click={handle_save_language}>{$_('profile.save')}</a>
						</div>
						<small>{$_('profile.note')}</small>
					</div>
				</div>
				<div class="divider gap-0 mt-0"></div>
			</li>
			<li>
				<a href="https://www.hi-ability.eu/" class="link link-hover">{$_('profile.website')}</a>
			</li>
			<li>
				<Link class="link link-hover" to="credits">{$_('profile.credits')}</Link>
			</li>
			<li>
				<div class="divider gap-0 mt-0"></div>
				<small class="text-gray-300">version {config.version}</small>
			</li>
		</ul>
		{/await}
	</div>

</BaseLayer>

